const Quote = {

    storageKey: "b2b_quote",

    get() {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    },

    save(items) {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
        this.updateBadge();
    },

    add(product) {

        const items = this.get();

        /*
         * Variant products:
         * use variant ID as the unique ID.
         *
         * Products without variants:
         * use product ID.
         */
        const itemId = product.variantId
            ? String(product.variantId)
            : String(product.id);


        const existing = items.find(
            item => String(item.id) === itemId
        );


        if (existing) {

            existing.quantity += product.quantity || 1;

        } else {

            items.push({

                id: itemId,

                productId:
                    product.productId || product.id,

                variantId:
                    product.variantId || null,

                title:
                    product.title,

                variantTitle:
                    product.variantTitle || "",

                image:
                    product.image,

                url:
                    product.url,

                quantity:
                    product.quantity || 1

            });

        }


        this.save(items);


        console.log(
            "Quote Basket:",
            this.get()
        );


        alert("✅ Added to Quote Basket");

    },


    updateQuantity(id, quantity) {

        const items = this.get();

        const item = items.find(
            item => String(item.id) === String(id)
        );

        if (!item) return;

        item.quantity = Math.max(
            1,
            quantity
        );

        this.save(items);

    },


    remove(id) {

        const items = this.get().filter(
            item =>
                String(item.id) !== String(id)
        );

        this.save(items);

    },


    clear() {

        localStorage.removeItem(
            this.storageKey
        );

        this.updateBadge();

    },


    updateBadge() {

        const badge =
            document.querySelector(
                ".quote-count"
            );

        if (!badge) return;

        const total =
            this.get().reduce(
                (sum, item) =>
                    sum + item.quantity,
                0
            );

        badge.textContent = total;

        badge.style.visibility =
            "visible";

    },


    init() {

        this.updateBadge();

    }

};


window.Quote = Quote;


/* ==========================================================
   GET SELECTED VARIANT
========================================================== */

function getSelectedVariant() {

    /*
     * First check URL.
     *
     * Example:
     * ?variant=54123202117996
     */
    const params =
        new URLSearchParams(
            window.location.search
        );


    const urlVariantId =
        params.get("variant");


    if (urlVariantId) {

        return {
            id: String(urlVariantId)
        };

    }


    /*
     * If no variant exists in URL,
     * check Shopify product form.
     */
    const variantInput =
        document.querySelector(
            'input[name="id"]'
        );


    if (
        variantInput &&
        variantInput.value
    ) {

        return {
            id:
                String(
                    variantInput.value
                )
        };

    }


    /*
     * No selected variant.
     *
     * This is NOT an error.
     * It can simply mean the product
     * has only the default variant.
     */
    return null;

}


/* ==========================================================
   PRODUCT PAGE - ADD TO QUOTE
========================================================== */

document.addEventListener(
    "click",
    async function (e) {

        const btn =
            e.target.closest(
                ".btn-quote-hero"
            );


        if (!btn) return;


        /*
         * Prevent the button from triggering
         * any form action.
         */
        e.preventDefault();


        /*
         * Prevent duplicate handling if another
         * click bubbles through the page.
         */
        if (
            btn.dataset.quoteProcessing ===
            "true"
        ) {

            return;

        }


        btn.dataset.quoteProcessing =
            "true";


        try {


            /*
             * Get selected variant.
             */
            const selectedVariant =
                getSelectedVariant();


            let variantId = null;

            let variantTitle = "";


            if (selectedVariant) {

                variantId =
                    selectedVariant.id;


                /*
                 * Get product URL.
                 */
                const productUrl =
                    btn.dataset.url ||
                    window.location.pathname;


                /*
                 * Shopify product JSON.
                 */
                const cleanUrl =
                    productUrl
                        .split("?")[0]
                        .replace(/\/$/, "");


                const productJsonUrl =
                    cleanUrl + ".js";


                try {

                    const response =
                        await fetch(
                            productJsonUrl
                        );


                    if (response.ok) {

                        const productData =
                            await response.json();


                        const variant =
                            productData.variants.find(
                                variant =>
                                    String(
                                        variant.id
                                    ) ===
                                    String(
                                        selectedVariant.id
                                    )
                            );


                        if (variant) {

                            variantTitle =
                                variant.title ||
                                "";

                        }

                    }

                } catch (error) {

                    console.warn(
                        "Variant information could not be loaded:",
                        error
                    );

                }

            }


            /*
             * "Default Title" means the product
             * does not have a meaningful variant.
             */
            if (
                variantTitle ===
                "Default Title"
            ) {

                variantTitle = "";

                variantId = null;

            }


            /*
             * Add product to quote.
             *
             * If variant exists:
             * variantId = selected variant ID
             *
             * If no variant:
             * variantId = null
             */
            Quote.add({

                id:
                    variantId ||
                    btn.dataset.id,

                productId:
                    btn.dataset.id,

                variantId:
                    variantId,

                title:
                    btn.dataset.title,

                variantTitle:
                    variantTitle,

                image:
                    btn.dataset.image,

                url:
                    btn.dataset.url,

                quantity: 1

            });


        } finally {


            /*
             * Allow clicking again after
             * the current operation finishes.
             */
            setTimeout(
                () => {

                    delete btn.dataset
                        .quoteProcessing;

                },
                500
            );

        }

    }
);


/* ==========================================================
   COLLECTION PAGE - ADD TO QUOTE
========================================================== */

document.addEventListener(
    "click",
    function (e) {

        const btn =
            e.target.closest(
                ".btn-quote-card"
            );


        if (!btn) return;


        e.preventDefault();


        /*
         * Prevent duplicate clicks.
         */
        if (
            btn.dataset.quoteProcessing ===
            "true"
        ) {

            return;

        }


        btn.dataset.quoteProcessing =
            "true";


        Quote.add({

            id:
                btn.dataset.id,

            productId:
                btn.dataset.id,

            variantId:
                null,

            title:
                btn.dataset.title,

            variantTitle:
                "",

            image:
                btn.dataset.image,

            url:
                btn.dataset.url,

            quantity: 1

        });


        setTimeout(
            () => {

                delete btn.dataset
                    .quoteProcessing;

            },
            500
        );

    }
);


/* ==========================================================
   INITIALIZE
========================================================== */

document.addEventListener(
    "DOMContentLoaded",
    function () {

        Quote.init();

    }
);